<iris-card *ngIf="loaded">
  <div
    class="state-network-list"
    *ngIf="stateOptions?.length && stateForm"
    [formGroup]="stateForm"
  >
    <h3 data-test="title-sondermind-provider-network">Credentialed insurance networks in</h3>

    <iris-dropdown
      formControlName="state"
      [options]="stateOptions"
      data-test="states">
    </iris-dropdown>
  </div>

  <mat-spinner *ngIf="loadingNewState" class="inline-material-spinner" diameter="50"></mat-spinner>

  <ng-container *ngIf="!loadingNewState">
    <div *ngIf="networks?.length" class="network-list">
      <div class="network-chip" *ngFor="let network of networks | sortProviderNetworkList">
        <iris-icon
          name="check"
          colorToken="$color-dec-kelly-100">
        </iris-icon>
        <span>{{ network.name }}</span>
      </div>
    </div>
    <div *ngIf="!networks?.length" class="network-list">
      <span>No providers found.</span>
    </div>
  </ng-container>

  <div class="support">
    <span>Note: Insurance information is read only and cannot be edited. If you see something that doesn't look right, contact&nbsp;</span>
    <a href="mailto:support&#64;sondermind.com">support&#64;sondermind.com</a>
    <span>.</span>
  </div>
</iris-card>
